import {UserIncident} from "../../../../domain/incident/Incident";
import React, {FC} from "react";

type Props = {
    item: UserIncident;
};

export const IncidentRowUnity: FC<Props> = ({item}) => {
    const {unity, unityId} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>UNIDAD</span>
            <span>{unity ? unity.label : unityId}</span>
        </div>
    );
};
